
import {
  Vue, Component, Prop, Watch,
} from 'vue-property-decorator';
import moment from 'moment';
import UpdateButton from '@/components/UpdateButton.vue';
import {
  Connection, Lead,
} from '@/types';
import DatePickerDialog from '@/components/DatePickerDialog.vue';
import { getLeadCustomValueBoolean, getLeadCustomValueDate } from '@/helpers';

moment.locale('it');

@Component({
  components: {
    UpdateButton,
    DatePickerDialog,
  },
})
export default class EditPracticeSendingDialog extends Vue {
  @Prop(Boolean) readonly value!: boolean;

  dialog = false
  valid = false

  datePickerDialog = false
  datePickerDate: string | null = null

  practiceSendingDate: Date | null = null
  practiceSendingAnagraficaDelay = false

  // La Connection selezionata
  get connection(): Connection | null {
    return this.$store.getters.currentConnection as Connection | null;
  }

  // La Lead selezionata (associata alla Connection)
  get lead(): Lead | null {
    return this.$store.getters.currentLead as Lead | null;
  }

  // La Connection è in caricamento?
  get loading(): boolean {
    return this.$store.getters.isConnectionLoading;
  }

  // La Connection è in aggiornamento?
  get updating(): boolean {
    return this.$store.getters.isConnectionUpdating;
  }

  // È necessario salvare le modifiche alla Connection?
  get dirty(): boolean {
    return this.$store.getters.isConnectionDirty;
  }

  refresh() {
    // Aggiorna i campi dai CustomValues della lead padre
    this.practiceSendingDate = (getLeadCustomValueDate(this.lead, 'practiceSendingDate') ?? null);
    this.practiceSendingAnagraficaDelay = (getLeadCustomValueBoolean(this.lead, 'practiceSendingAnagraficaDelay') ?? false);
  }

  onClickDate() {
    // Imposta l'eventuale data precedentemente selezionata
    const prevDate = this.practiceSendingDate
      ? moment(this.practiceSendingDate).toISOString(true).substr(0, 10)
      : null;
    this.datePickerDate = prevDate;

    // Apre il dialog per la selezione della data
    this.datePickerDialog = true;
  }

  onClearDate() {
    const update = {
      practiceSendingDate: null,
    } as { [key: string]: unknown };

    this.practiceSendingDate = null;

    this.$store.dispatch('updateConnectionFields', {
      fields: update,
    });
  }

  onSelectDate(date: string | null) {
    // Chiudo il dialog per la selezione della data
    this.datePickerDialog = false;

    // Trasforma in Date
    const selectedDate = date ? moment(date, 'YYYY-MM-DD').toDate() : null;

    const update = {
      practiceSendingDate: selectedDate,
    } as { [key: string]: unknown };

    this.practiceSendingDate = selectedDate;

    this.$store.dispatch('updateConnectionFields', {
      fields: update,
    });
  }

  onToggleAnagraficaDelay() {
    const update = {
      practiceSendingAnagraficaDelay: this.practiceSendingAnagraficaDelay,
    } as { [key: string]: unknown };

    this.$store.dispatch('updateConnectionFields', {
      fields: update,
    });
  }

  @Watch('value')
  onValueChange(val: boolean) {
    this.dialog = val;
    if (val) this.refresh();
  }

  @Watch('dialog')
  onDialogChange(val: boolean) {
    if (this.value !== val) {
      this.$emit('input', val);
    }

    if (!val) {
      this.$store.dispatch('unselectConnection');
    }
  }

  get appendIcon(): string | null { return this.fieldsDisabled ? 'mdi-lock' : null; }

  mDate(date: Date | null | undefined): string | null { return date ? moment(date).format('L') : null; }

  get fieldsDisabled(): boolean {
    return this.lead?.status !== 'open'
      || this.loading
      || this.updating;
  }

  onCancel() {
    this.dialog = false;
    this.$emit('cancel');
  }

  async onSave() {
    await this.$store.dispatch('updateSelectedConnection');
    this.dialog = false;
  }
}
